import { Spin } from 'antd';
import { Spin as SpinV5 } from 'antd-v5';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import moment from 'moment';
import 'moment-timezone';
import 'rc-trigger/assets/index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-quill-emoji/dist/quill-emoji.css';
import 'react-quill/dist/quill.snow.css';
import { HashRouter as Router } from 'react-router-dom';
import 'utils/markdownUtils';
import startCheckingForNewBuild from 'utils/refreshUtil';

import App from './App';
import ACLoadingIcon from './ac-components/ac-icons/LoadingIcon';
import ConfigurationProvider from './components/ConfigurationProvider';
import message from './components/CustomMessage';
import { LoadingIcon } from './components/Icons';
import './less/index.less';
import { setupAPIClientNotifications } from './restAPI/index';
import { initSentry } from './sentry';

dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(customParseFormat);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

moment.updateLocale('en', {
  relativeTime: {
    m: '1 minute',
    h: '1 hour',
    M: '1 month',
    y: '1 year',
  },
});

Spin.setDefaultIndicator(<LoadingIcon />);
SpinV5.setDefaultIndicator(<ACLoadingIcon className="font-size-24" />);

initSentry();

// Inject the error-toast side-effect into the API layer so restAPI/index.ts
// has no direct import of any UI/component module (breaks context→API→UI cycle).
setupAPIClientNotifications(message.error);

ReactDOM.render(
  <Router>
    <ConfigurationProvider>
      <App />
    </ConfigurationProvider>
  </Router>,
  document.getElementById('root'),
);

startCheckingForNewBuild();
